module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TN-6c77881a5ae6177a13ea696a46ad9aa7.png";